import type { ReactNode } from 'react';
import { cx } from './cx.ts';

export interface EmptyStateProps {
  title: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  /** The next action (never just "No data", 04 §4.0 E0). */
  action?: ReactNode;
  variant?: 'inline' | 'page';
  className?: string;
}

export function EmptyState({ title, description, icon, action, variant = 'inline', className }: EmptyStateProps) {
  return (
    <div className={cx('yk-empty', `yk-empty--${variant}`, className)}>
      {icon ? <span className="yk-empty__icon" aria-hidden="true">{icon}</span> : null}
      <p className="yk-empty__title">{title}</p>
      {description ? <p className="yk-empty__desc">{description}</p> : null}
      {action ? <div className="yk-empty__action">{action}</div> : null}
    </div>
  );
}

